import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Home, Scan, ShoppingBag, Settings, BarChart3, ClipboardList } from 'lucide-react';

const BottomNavigation = ({ currentPage, onNavigate, isAdmin, isAgent, userRole }) => {
  const { t, language } = useLanguage();

  // Manager has access to import page
  const isManager = userRole === 'manager';
  const isSupervisor = userRole === 'supervisor';
  const canAccessAdmin = isAdmin || isManager;

  const navItems = isAgent ? [
    { id: 'agent-dashboard', icon: Home, label: language === 'fr' ? 'Accueil' : 'Home' },
    { id: 'analysis', icon: Scan, label: language === 'fr' ? 'Conseil' : 'Consult' },
    { id: 'stats', icon: BarChart3, label: language === 'fr' ? 'Stats' : 'Stats' },
    ...(canAccessAdmin ? [{ id: 'admin', icon: isManager ? ClipboardList : Settings, label: isManager ? (language === 'fr' ? 'Saisie manager' : 'Manager input') : t('admin') }] : []),
  ] : [
    { id: 'dashboard', icon: Home, label: t('home') },
    { id: 'analysis', icon: Scan, label: t('scan') },
    { id: 'products', icon: ShoppingBag, label: t('products') },
    ...(canAccessAdmin ? [{ id: 'admin', icon: isManager ? ClipboardList : Settings, label: isManager ? (language === 'fr' ? 'Saisie manager' : 'Manager input') : t('admin') }] : []),
  ];

  return (
    <>
      {/* Spacer to prevent content from being hidden behind bottom nav */}
      <div className="h-[calc(70px+env(safe-area-inset-bottom,0px))] sm:h-[70px]" aria-hidden="true" />
      
      {/* Bottom Navigation */}
      <nav 
        className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-[#E7E5E4] z-50"
        style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
        data-testid="bottom-navigation"
      >
        <div className="max-w-lg mx-auto flex items-center justify-around px-2 py-2 h-[70px]">
          {navItems.map((item) => {
            const isActive = currentPage === item.id;
            const Icon = item.icon;
            
            return (
              <button
                key={item.id}
                onClick={() => onNavigate(item.id)}
                className={`flex flex-col items-center justify-center py-2 px-3 sm:px-4 transition-colors duration-200 ${
                  isActive ? 'text-[#0EA5E9]' : 'text-[#78716C]'
                }`}
                data-testid={`nav-${item.id}`}
              >
                <div className={`nav-icon p-2 rounded-xl transition-colors duration-200 ${
                  isActive ? 'bg-[#E0F2FE] text-[#0EA5E9]' : ''
                }`}>
                  <Icon className="w-5 h-5" />
                </div>
                <span className="text-xs mt-1 font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default BottomNavigation;
